export const GET_USER_NFC_CARDS_SUCCESS = "GET_USER_NFC_CARDS_SUCCESS";
export const GET_USER_NFC_CARDS_FAILURE = "GET_USER_NFC_CARDS_FAILURE";

export const APPLY_NFC_CARD_SUCCESS = "APPLY_NFC_CARD_SUCCESS";
export const APPLY_NFC_CARD_FAILURE = "APPLY_NFC_CARD_FAILURE";

export const UPDATE_NFC_CARD_BANK_DETAILS_SUCCESS =
  "UPDATE_NFC_CARD_BANK_DETAILS_SUCCESS";
export const UPDATE_NFC_CARD_BANK_DETAILS_FAILURE =
  "UPDATE_NFC_CARD_BANK_DETAILS_FAILURE";

export const UPLOAD_NFC_CARD_PHOTO_SUCCESS = "UPLOAD_NFC_CARD_PHOTO_SUCCESS";
export const UPLOAD_NFC_CARD_PHOTO_FAILURE = "UPLOAD_NFC_CARD_PHOTO_FAILURE";

export const NFC_CARD_PAYMENT_SUCCESS = "NFC_CARD_PAYMENT_SUCCESS";
export const NFC_CARD_PAYMENT_FAILURE = "NFC_CARD_PAYMENT_FAILURE";
